import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloProvider } from '@apollo/client/react'
import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from 'react-oidc-context'
import apolloClient from './apollo-client'
import AlertContextProvider from './components/AlertContextProvider/AlertContextProvider'
import { OPEN_ID_SETTINGS } from './config/o-auth'
import App from './pages/App'
import reportWebVitals from './reportWebVitals'
import './index.css'
import './styles/global/_flex.scss'
import './styles/global/main.scss'

const theme = createTheme({
  typography: {
    fontFamily: ['HP Simplified', 'Arial', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#0096d6',
      dark: '#075782',
      light: '#0096D6',
    },
    secondary: {
      main: '#7d3894',
      dark: '#4B4096',
      light: '#4B4096',
    },
    error: {
      main: '#d6002a',
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider {...OPEN_ID_SETTINGS} monitorSession={true} loadUserInfo={true}>
            <AlertContextProvider>
              <App />
            </AlertContextProvider>
          </AuthProvider>
        </ThemeProvider>
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
